import { getAvatar } from 'utils';
import { instagram_comment_avatar } from 'ui-components/ui-images';
import { t } from 'i18next';

export const bulletinAdapter = (bulletin) => {
  const counts = JSON.parse(
    bulletin.counter?.replace('iranian-platforms', 'nativePlatforms')
  );

  return {
    id: bulletin.id,
    title: bulletin.title,
    contentCounts: counts,
    sorts: JSON.parse(bulletin.sorts),
  };
};

/** شناسهٔ پایدار برای یک ردیف فهرست بولتن (کلید درفت PDF و لینک فهرست). */
function resolveBulletinTocRowStableId(platform, item, listIndex) {
  const candidates = [
    item?.id,
    item?.post_id,
    item?.postId,
    item?.['post.id'],
    item?.content_id,
  ];
  for (let i = 0; i < candidates.length; i += 1) {
    const c = candidates[i];
    if (c != null && String(c).trim() !== '') {
      return String(c);
    }
  }
  if (item?.link_to != null && String(item.link_to).trim() !== '') {
    return `link_${String(platform)}_${String(item.link_to)}`;
  }
  return `idx_${String(platform)}_${Number(listIndex)}`;
}

export const bulletinTableOfContentsAdaptor = (
  platform,
  item,
  listIndex = 0
) => {
  let avatar = item?.avatar ? getAvatar(item?.avatar, platform) : null;
  let title = item?.title || item?.username || null;
  let description = item?.description;

  if (platform === 'news') {
    avatar = getAvatar(item?.['relation.avatar'], platform);
    title = item?.['relation.title'];
    description = item?.title || item?.description || null;
  }
  if (platform === 'instagramstories') {
    avatar = item?.avatar ? getAvatar(item?.avatar, 'story') : null;
  }
  if (platform === 'instagramcomments') {
    avatar = instagram_comment_avatar;
    title = t('common:instagramNotDetermined');
  }
  if (platform === 'newspaper') {
    avatar = getAvatar(
      item?.resurce_avatar || item?.['relation.avatar'] || item?.avatar,
      platform
    );
  }

  return {
    contentPlatform: item?.contentPlatform || null,
    id: resolveBulletinTocRowStableId(platform, item, listIndex),
    avatar: avatar,
    postId: item?.post_id || null,
    title: title,
    description: description,
  };
};

export const bulletinInfluenceResourcesAdapter = (platform, item) => {
  return {
    avatar: item?.avatar ? getAvatar(item?.avatar, platform) : null,
  };
};
